<template>
  <div class="mb-2 p-4">
    <validation-observer ref="customRequestFormModel" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            :icon="customIcon"
            :title="formTitle"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div v-if="showInputDate" class="col-12 col-md-3 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              :label="formDateTitle"
              v-model="model.deliveryDate"
              :min-date="getInitialDate"
              :max-date="maxDate"
              placeholder="DD/MM/YYYY"
              class="custom-datetime-picker-approval-form"
              container-class="w-100"
              :error="errors[0]"
              custom-error-msg="La fecha es requerida"
              :disabled="isDateReadOnly"
            />
          </validation-provider>
        </div>
        <div class="col-12 mb-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario:"
              v-model="model.comment"
              :error="errors[0]"
              custom-error-msg="Este campo es requerido"
              :show-char-count="true"
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from "ActionButton";
import IconView from "icon-view";
import CustomTextArea from "CustomTextArea";
import CustomCallout from "custom-callout";
import CustomResultNotFound from "custom-result-not-found";
import CustomDatePicker from "custom-date-picker";
import inventoryOrderMaterialsAndEquipments from '@/services/api/inventoryOrderMaterialsAndEquipments.api';
import moment from "moment";
import ACTIONS from "@/utils/constants/inventoryOrderBooksRowAction";
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin.js";

export default {
  name: "customRequestForm",
  components: {
    ActionButton,
    IconView,
    CustomTextArea,
    CustomCallout,
    CustomResultNotFound,
    CustomDatePicker
  },
  mixins: [alertMixin],
  props: {
    showInputDate: {
      type: Boolean,
      default: false
    },
    formTitle: {
      type: String,
      required: true
    },
    formDateTitle: {
      type: String,
      required: false,
      default: "Fecha:"
    },
    customIcon: {
      type: String,
      required: true
    },
    formInfo: {
      type: Object,
      required: true
    },
    action: {
      type: Number,
      required: false,
      default: null
    },
    isDateReadOnly: {
      type: Boolean,
      required: false,
      default: () => false
    },
    minDate: {
      type: Date,
      required: false,
      default: () => null
    },
    maxDate: {
      type: Date,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      initialDate: null,
      model: {
        comment: "",
        deliveryDate: null
      }
    };
  },
  computed: {
    getInitialDate() {
      return new Date(this.initialDate) || new Date();
    }
  },
  mounted() {
    this.getCustomFormData();
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.customRequestFormModel.validate();
      if (!isvalid) {
        this.ShowToast(
          "Alerta",
          "Por favor completa los campos requeridos.",
          "error"
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        "Confirmación",
        `¿Está seguro que desea guardar la información documentada?`,
        "Sí",
        "No"
      );

      if (!confirmed) return;

      this.$emit("save", this.sendCustomFormData());
    },
    async getCustomFormData() {
      let data = {};

      switch (this.action) {
        case ACTIONS.DeliverToSchool:
          data = await inventoryOrderMaterialsAndEquipments.getMaterialRequestAssignmentDate(
            this.formInfo.id
          );
          this.initialDate = moment(data?.data?.assingmentDate)
            .add(-1, "days")
            .toDate();
          break;
        case ACTIONS.ReceivedByMaster:
          data = await inventoryOrderMaterialsAndEquipments.getMaterialRequestSchoolDeliveryDate(
            this.formInfo.id
          );
          if (!data?.data?.assingmentDate) {
            data = await inventoryOrderMaterialsAndEquipments.getMaterialRequestPendingTeacherDeliveryDate(
              this.formInfo.id
            );
          }
          this.initialDate = moment(data?.data?.assingmentDate)
            .add(-1, "days")
            .toDate();
          break;
        case ACTIONS.ApprovePurchase:
          this.model.deliveryDate = new Date();
          this.initialDate = new Date();
          break;
        default:
          this.initialDate = this.minDate;
      }
    },
    sendCustomFormData() {
      let payload = {};

      switch (this.action) {
        case ACTIONS.Reject:
          payload = {
            id: this.formInfo.id,
            comment: this.model.comment
          };
          break;
        default:
          payload = {
            id: this.formInfo.id,
            comment: this.model.comment,
            actionDate: this.model.deliveryDate
          };
      }

      return payload;
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .custom-datetime-picker-approval-form .width-container {
  width: 100% !important;
}
::v-deep .custom-datetime-picker-approval-form .fa.fa-calendar::before {
  content: "\f783";
  font-weight: 400;
}
::v-deep .custom-datetime-picker-approval-form .fa.fa-calendar-day::before {
  content: "\f783";
  font-weight: 400;
}
</style>
